module.exports = __webpack_public_path__ + "static/media/calidad.ba028889.png";